import React from 'react'
import PropTypes from 'prop-types'

export const numberToStrCurrency = (value, decimalPlaces = 2) => {
  return parseFloat(`${value}`).toLocaleString('pt-BR', {
    currency: 'BRL',
    minimumFractionDigits: decimalPlaces || 0,
    maximumFractionDigits: decimalPlaces || 0
  })
}

const CurrencyLabel = ({
  id,
  label,
  value = '0',
  decimalPlaces,
  className,
  showpointsName = true,
  prefixLabel = ''
}) => {
  if (isNaN(value)) {
    value = 0
  }
  const valueFormated = numberToStrCurrency(value, decimalPlaces)
  return (
    <span id={id} className={`price-value ${className}`} aria-label={`${prefixLabel} ${valueFormated} ${showpointsName ? label : ''}`}>
      {`${prefixLabel} ${valueFormated} ${showpointsName ? label : ''}`}
    </span>
  )
}

CurrencyLabel.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  decimalPlaces: PropTypes.number,
  className: PropTypes.string,
  showpointsName: PropTypes.bool,
  prefixLabel: PropTypes.string
}

export default CurrencyLabel



// WEBPACK FOOTER //
// ./src/Shared/CurrencyLabel/CurrencyLabel.js